import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddressPAF } from '../address-finder/address-finder.service';

@Injectable({
  providedIn: 'root',
})
export class AddressService {

  constructor(private _http: HttpClient) { }

  checkPostcodeValidity(postcode: string): Observable<boolean> {
    return this._http.get<boolean>(`${environment.apiUrl}/api/addresses/validpostcode/${postcode}`);
  }

  getAddressMatches(postcode: string): Observable<AddressPAF[]> {
    return this._http.get<AddressPAF[]>(`${environment.apiUrl}/api/addresses/match/${postcode}`);
  }

}
